import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import NomenclaturesAreaTypeApiService from '@/modules/settings/services/NomenclaturesAreaTypeApiService';

// eslint-disable-next-line no-unused-vars
const SelectUsersAreaAccess = ({value, onChange, translation, fieldKey, form, defaultValue, setAreaAccess, ...props}) => {

  const onChangeValues = useCallback((value) => {
    const temp = form.getFieldValue('registersAccess');
    if (!temp[fieldKey]) {
      temp[fieldKey] = {};
    }
    temp[fieldKey].areaAccess = value;
    setAreaAccess && setAreaAccess(value);
    form.setFieldsValue({registersAccess: temp});
    onChange && onChange(temp);
  }, [fieldKey, form, onChange, setAreaAccess]);

  return (
    <SelectElementCmp
      queryKey={`areaAccess-user-select-${fieldKey}`}
      key={`areaAccess-user-select-${fieldKey}`}
      service={NomenclaturesAreaTypeApiService}
      defaultValue={defaultValue}
      value={typeof value === 'object' ? value?.name : value}
      onChange={onChangeValues}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      // className={classNames('custom-select', styles.centerSelectContent)}
      style={{width: '120px'}}
      placeholder={translation('placeholderSelectServices')}
      {...props}
    />
  );
};

SelectUsersAreaAccess.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  form: PropTypes.object,
  translation: PropTypes.func,
  fieldKey: PropTypes.string,
  defaultValue: PropTypes.array,
  setAreaAccess: PropTypes.func
};


export default memo(SelectUsersAreaAccess);

const UsersAreaAccessView = ({value}) => {

  return (
    <div>
      {value?.name || 'N/A'}
    </div>
  );
};

UsersAreaAccessView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderUsersAreaAccess = (text) => {
  return (
    <UsersAreaAccessView value={text}/>
  );
};
